import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { environment } from "../../environments/environment";
@Injectable()
export class AppCustomerService {
  api_url: string = environment.apiEndPoint;

  constructor(private http: HttpClient) {}

  getToken() {
    return localStorage.getItem(environment.TOKEN_SECRET);
  }
 
  getOrders(){
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.get<any>(this.api_url + 'client_orders',configs)
  }
  updateUserForCreditLimit(data: any) {
    const configs = {
      withCredentials: true,
      headers: { Authorization: `Bearer ${this.getToken()}` },
    };
    return this.http.post<any>(this.api_url + 'updateUserForCreditLimit', data, configs)
  }
}



// WEBPACK FOOTER //
// ./src/app/appcustomerlist/appcustomer.service.ts